import { callAuthorizedGraphQLEndpoint } from '../../../../../../Module/graphQL'

export async function getBrandAmbassadorActivity(variables) {
  const query = `query ($ambassadorId:ID! $first:Int $after:String) {
    brandAmbassador(ambassadorId:$ambassadorId) {
      missions (first:$first after:$after) {
        pageInfo {
          endCursor
          hasNextPage
        }
        edges {
        node {
           id
           rating
           status
           timeRangeStart
           timeOfDay
           totalFlyersDistributed
           cityPlan{
            city{
              name
            }
           }
           location{
             name
            }
           client{
             name
           }
           conversions{
             nodes {
               id
               timestamp
               metric {
                id
                name
                }
              }
            }
          spyInformation{
              spyDetails{
                checkInTime
                }
            }
          }
        }
      }  
    }
  }`
  const req = await callAuthorizedGraphQLEndpoint(query, variables)
  return req.json()
}



// WEBPACK FOOTER //
// ./src/Containers/City/Page/Ambasador/Components/ActivitySection/gql.js